import { useStoreState } from './state'

// Rôle porté par le token de session (cf. state/models/utils.ts, qui décode les
// claims). Deux rôles existent : « admin », qui voit tout le back-office, et
// « client », un compte d'accès rattaché à un ou plusieurs espaces qui ne peut
// consulter que ces espaces et leurs statistiques (ticket #7445).

export function useIsClient() {
  return useStoreState((store) => store.utils.session.claims.role === 'client')
}

// Espaces réellement accessibles au compte connecté. On lit la liste chargée
// depuis l'API — déjà scopée — plutôt que les `spaces` du token : les deux
// peuvent diverger (espace supprimé mais toujours présent dans le token), et
// c'est cette liste qui alimente la navigation.
export function useAccessibleSpaces() {
  return useStoreState((store) => store.space.list)
}

// Compte administrateur (par opposition à un compte d'accès « client »). On lit
// la claim `admin` du token, celle-là même que testent les gardes de l'API —
// plutôt que `!useIsClient()`, qui renverrait vrai pour un token sans rôle.
export function useIsAdmin() {
  return useStoreState((store) => store.utils.session.claims.admin)
}
